module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-3-4a00f76bea20b2004c4fd728822708ae.webp";